import { Block } from "@mezo-org/mezo-clay"

import { selectIsConnected, useDappSelector } from "#/redux-state"

import HomepageMainSectionGuest from "./HomepageMainSectionGuest"
import HomepageMainSectionUser from "./HomepageMainSectionUser"

export default function HomepageMainSection() {
  const isConnected = useDappSelector(selectIsConnected)

  return (
    <Block backgroundColor="#F3F3F3">
      {isConnected ? <HomepageMainSectionUser /> : <HomepageMainSectionGuest />}
    </Block>
  )
}
